export const convertUSDtoCents = (value: string): number => {
  const dollars = parseFloat(value.replace(/\$/g, '').replace(/,/g, '').trim());
  if (isNaN(dollars)) {
    throw new Error('Input is not a valid value.');
  }

  return Math.round(dollars * 100);
};

export const convertCentsToUSD = (
  cents: number,
  omitDollarSign: boolean = true,
): string => {
  if (!Number.isInteger(cents)) {
    return '0.00';
  }
  const dollars = cents / 100;
  const formatted = dollars.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return omitDollarSign
    ? formatted.replace('$', '').replace(/,/g, '')
    : formatted;
};
